<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        <template #status="{item}">
          <td>
            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>
          </td>
		  <td>
            <CButton color="primary" class="px-4" @click="edit(item.username)">Edit</CButton>
			<CButton color="danger" class="px-4" @click="myModal = true" >Delete</CButton>			
          </td>
        </template>
      </CDataTable>
	  <CModal
      :show.sync="myModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Delete"
      size="sm"
      color="dark"
    >
      Are you wan't to delete this?
      <template #header>
        <h6 class="modal-title">Delete</h6>
        <CButtonClose @click="myModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="myModal = false" color="danger">Cancel</CButton>
        <CButton @click="deleterow" color="success">Delete</CButton>
      </template>
    </CModal>  
	 
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'Material_master',
  data () {
    return {
      myModal: false
	}
  },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return ['username', 'registered', 'role', 'status']
      }
    },
    caption: {
      type: String,
      default: 'Material_master'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
	edit(id){
		console.log('edit '+id);
		this.$router.push({path:'edit_Material'})
	}
	,
	deleterow(id){
		console.log('delete '+id);
		alert('delete');
		this.myModal= false;
		//this.$router.push({name:'add_origin'})
	}
  }
}
</script>
